export default function () {
  // No department dropdown here — the Sales Dashboard has quick-pick
  // department buttons that fill the business-unit filter directly.
  return [
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
 /*    { key: 'banner' }, { key: 'affiliate' }, { key: 'campaign' }, */

  ]
}
